import { __awaiter } from "tslib";
import Vue from 'vue';
import navigationBar from '@/components/global/top-bar/navigationBar.vue';
import mobNavigationBar from '@/components/global/top-bar/mobNavigationBar.vue';
import mobUserBar from '@/components/global/top-bar/mobUserBar.vue';
import AppSwitcher from '@/components/global/top-bar/appSwitcher.vue';
import { mapGetters } from 'vuex';
import { ItemClosingStatusEnum, ItemCloseRecordSource } from '@/store/modules/mainPageModules/utils/itemClose';
import _ from 'lodash';
import { getPassportUrl } from '@/utils/other';
import { parseNotificationString } from '@/constants/notifications';
import Cookies from 'js-cookie';
import HeaderBackground from './headerBackground.vue';
import { getServiceConfigProperty } from '@/constants/services';
import PartnerLogo from './partnerLogo.vue';
let remote;
export default Vue.extend({
    name: 'top-bar',
    data: () => ({
        mobNavigationIsOpened: false,
        mobUserBarIsOpened: false,
        windowScrolled: false,
        closingAwait: false,
        exchangesList: [
            'binance',
            'bybit',
            'okx',
            'moex'
        ],
        menuData: {
            common: {
                accountBadge: {
                    state: 'hidden'
                }
            },
            menu: {}
        },
        menuElError: false,
        menuLoaded: false
    }),
    computed: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, mapGetters('user', ['getUserData'])), mapGetters('mainPageModules', ['getLimitsBidsTable', 'getPositionsTable', 'getBinanceConnectionFault', 'getSocketConnectionPermission'])), mapGetters(['isUiBlocking'])), mapGetters('notifications', ['getTopBar'])), { currentTopBarNotification() {
            const [current] = this.getTopBar;
            return current;
        },
        getUserFirstLetters() {
            var _a, _b;
            const vm = this;
            return ((_a = vm.getUserData.first_name.split('')[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) + ((_b = vm.getUserData.last_name.split('')[0]) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || '';
        }, getHeadingForHeader() {
            if (this.maw(1200) && this.miw(560))
                return 44;
            if (this.maw(560))
                return 88;
            return this.miw(1200) ? 41 : 44;
        }, apexColors() {
            return {
                darkest: '#763124',
                mediumDark: '#271c1f',
                mediumLight: '#d4342d',
                lightest: '#9c9ba1'
            };
        },
        WLColors() {
            return {
                darkest: '#fff',
                mediumDark: '#255dc6',
                mediumLight: '#fff',
                lightest: '#255dc6'
            };
        },
        LiSAColors() {
            return {
                darkest: '#C150D2',
                mediumDark: '#8185A4',
                mediumLight: '#2F3C94',
                lightest: '#00FF75'
            };
        }, itWhitelistDomen() {
            return getServiceConfigProperty('companyAbrv') === 'WL';
        } }),
    methods: {
        getMenuData() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield this.services.v2.widgets.getUserMenuData();
                    if (response.status === 200) {
                        this.menuData = response.data.payload;
                        this.exchangesList = this.exchangesList.filter((el) => {
                            var _a;
                            return ((_a = this.menuData.exchanges[el]) === null || _a === void 0 ? void 0 : _a.state) !== 'hidden';
                        });
                        this.menuElError = false;
                    }
                    if (!response.success)
                        throw Error();
                }
                catch (e) {
                    this.menuElError = true;
                    console.log(e, 'Не удалось получить данные по пользовательскому меню');
                }
                finally {
                    this.menuLoaded = true;
                }
            });
        },
        changeAccountBadge() {
            return __awaiter(this, void 0, void 0, function* () {
                const initBadgeData = this.menuData.common.accountBadge.state;
                this.menuData.common.accountBadge.state = 'hidden';
                try {
                    const response = yield this.services.v2.widgets.setAccountBadge('hidden');
                    if (!response.success)
                        throw new Error('');
                }
                catch (e) {
                    this.menuData.common.accountBadge.state = initBadgeData;
                }
            });
        },
        handleUserBarToggle(isOpen) {
            this.mobUserBarIsOpened = isOpen;
            if (isOpen) {
                window.ym(96934969, 'reachGoal', 'menu', { sessionId: Cookies.get('stakanSessionID'), userId: this.getUserData.pk });
                window.ym(96934935, 'reachGoal', 'menu', { sessionId: Cookies.get('stakanSessionID'), userId: this.getUserData.pk });
            }
            if (this.menuData.common.accountBadge.state === 'hidden')
                return;
            this.changeAccountBadge();
        },
        logout() {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const cookie = vm.$cookies.get('jwtr');
                const response = yield vm.services.authorization.logout({ refresh: cookie });
                const location = window.location;
                const host = location.hostname.split('.').reverse()[1] + '.' + location.hostname.split('.').reverse()[0];
                if (response.success) {
                    vm.$cookies.set('jwtr', '', {
                        expires: -1,
                        domain: '.' + host
                    });
                    window.location.href = getPassportUrl('/', { withAcceptor: true });
                }
            });
        },
        parseNotificationString(body) {
            return parseNotificationString(body, this.currentTopBarNotification.vars);
        },
        handleNotificationTopBar() {
            window.open(this.parseNotificationString(this.currentTopBarNotification.actions.mainButton.url), '_self');
        },
        handleMinimizeClick() {
            remote.BrowserWindow.getFocusedWindow().minimize();
        },
        handleFullscreenClick() {
            remote.BrowserWindow.getFocusedWindow().setFullScreen(!remote.BrowserWindow.getFocusedWindow().isFullScreen());
        },
        handleCloseClick() {
            remote.BrowserWindow.getFocusedWindow().close();
        },
        reloadPage() {
            window.location.reload();
        },
        closeAll() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return __awaiter(this, void 0, void 0, function* () {
                this.closingAwait = true;
                const positions = this.getPositionsTable.items.map((item) => {
                    const volume = item.direction === 'Шорт' ? item.volume.multipliedBy(-1) : item.volume;
                    return {
                        ticker: item.ticker,
                        amount: volume.toString()
                    };
                });
                const limits = this.getLimitsBidsTable.items.map((item) => {
                    return {
                        orderId: item.id,
                        source: item.section === 'Спот' ? 'spot' : 'futures',
                        ticker: item.ticker
                    };
                });
                const response = yield this.services.v2.trade.closeAllOrdersAndPositions({ positions, limits });
                const limitsExtra = (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.limits) === null || _c === void 0 ? void 0 : _c.extra;
                const positionsExtra = (_f = (_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.payload) === null || _e === void 0 ? void 0 : _e.positions) === null || _f === void 0 ? void 0 : _f.extra;
                const limitsRequested = (_j = (_h = (_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.payload) === null || _h === void 0 ? void 0 : _h.limits) === null || _j === void 0 ? void 0 : _j.requested;
                const positionsRequested = (_m = (_l = (_k = response === null || response === void 0 ? void 0 : response.data) === null || _k === void 0 ? void 0 : _k.payload) === null || _l === void 0 ? void 0 : _l.positions) === null || _m === void 0 ? void 0 : _m.requested;
                const isValidAnswer = [limitsExtra, positionsExtra, limitsRequested, positionsRequested].every(el => _.isArray(el));
                if (isValidAnswer) {
                    if (limitsExtra.length || positionsExtra.length) {
                        this.$store.dispatch('mainPageModules/reloadByError', { cause: 'extra при закрытии всего' });
                    }
                    else {
                        limitsRequested.forEach((item) => {
                            if (item.status === ItemClosingStatusEnum.unhandledError) {
                                return;
                            }
                            this.$store.dispatch('mainPageModules/setOrderClose', { by: ItemCloseRecordSource.wl, id: item.id });
                        });
                        positionsRequested.forEach((item) => {
                            if (item.status === ItemClosingStatusEnum.unhandledError) {
                                return;
                            }
                            this.$store.dispatch('mainPageModules/setPositionClose', { by: ItemCloseRecordSource.wl, ticker: item.ticker });
                        });
                    }
                    this.$store.dispatch('alertsBus/openAlert', {
                        title: this.$t('popups.titles.success'),
                        type: 'success',
                        autoDelete: true,
                        content: this.$t('popups.content.positionsAndBidsClosed')
                    });
                }
                else {
                    this.$store.dispatch('alertsBus/openAlert', {
                        title: this.$t('popups.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        content: this.$t('popups.content.positionsAndBidsNotClosed')
                    });
                }
                this.closingAwait = false;
            });
        }
    },
    mounted() {
        const vm = this;
        vm.getMenuData();
        const { headerRef } = vm.$refs;
        if (vm.$isElectron) {
            remote = require('electron').remote;
        }
    },
    components: {
        navigationBar,
        mobNavigationBar,
        mobUserBar,
        AppSwitcher,
        HeaderBackground,
        PartnerLogo
    }
});
